import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {

  return (

    <div id="header-affix-wrap" className="header-wrap i">
      <header id="header" className="header header-6 fs-12 menu-center always-sticky    has-menu">
        <div className="container-fluid">
          <div className="logo-wrap">
            <a className="logo logo-left with-image" href="/" itemProp="url">
              <img
                src="./assets/s_logo.png"
                alt="Foxearch Logo"
              />
              <img
                src="./assets/logo_white.png"
                alt="Foxearch"
                style={{height: '40px','margin-bottom': '6px'}}
              />
            </a>				</div>
          <div id="overlay" />
          <nav id="nav_top" className="top-nav" aria-label="Top Menu">
            <ul id="menu-main-menu" className="top-menu menu-many-items">
              <li id="menu-item-1350" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home menu-item-1350"><a href ="/home" aria-current="page" data-hover="Home">Home</a></li>
              <li id="menu-item-9259" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-9259"><Link to ="/productDemo" data-hover="Services">Product Demo</Link></li>
              <li id="menu-item-9259" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-9259"><a href ="/aboutUs" data-hover="Services">About Us</a></li>

              {/* <li id="menu-item-1321" className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-1277 current_page_item menu-item-1321">
                <a href="/aboutUs" data-hover="About">About Us</a>
                </li> */}

              <li id="menu-item-1314" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-1314"><Link to ="/careers" data-hover="Pages">Careers</Link>

              </li>
              <li id="menu-item-9285" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-9285"><Link to ="/blogs" data-hover="Blog">Blogs</Link>

              </li>
              <li id="menu-item-9286" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-9286"><Link to ="/contactUs" data-hover="Contacts">Contact Us</Link>

              </li>
              <li id="menu-item-9287" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-9286"><Link to ="/login" data-hover="Contacts">Login</Link>

              </li>
            </ul>							<button id="nav_close" className="nav-btn" aria-controls="nav_top" aria-expanded="true" aria-label="Top Menu Close" />


          </nav>
          <button id="nav_toggle" className="nav-btn" aria-controls="nav_top" aria-expanded="false" aria-label="Top Menu Toggler" />

        </div>
      </header>
    </div>
  );
}

export default Header;
